import axios from '../../../../api/axios';
import React, {useState,useEffect} from 'react'
import {EyeFill,PencilFill,Trash3Fill,PersonPlus} from "react-bootstrap-icons"
import { useNavigate,useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import loadingIcon from '../../../../Images/loading.gif'


function Classe() {

   
    const [classes_initiales,setClasses_initiales]=useState([])
    const [curentpage,setCurentpage]=useState(1)
    const [search,setSearch]=useState('')
    const [recordperpage,setRecordperpage]=useState(50)
    let navigate=useNavigate()
    localStorage.setItem("lastpage","/classe_initiale")
    const lastIndex=curentpage * recordperpage
    const firstIndex=lastIndex - recordperpage
    const {id}=useParams()
    const records= search.toLowerCase() === '' ? classes_initiales.slice(firstIndex, lastIndex) : classes_initiales.filter((classe_initiale)=>{return search.toLowerCase() === '' ? classe_initiale : classe_initiale.nom.toLowerCase().includes(search)}).slice(firstIndex, lastIndex)
    const recordNpage=search.toLowerCase() === '' ? classes_initiales : classes_initiales.filter((classe_initiale)=>{ return classe_initiale.nom.toLowerCase().includes(search)})
    const npage=Math.ceil(recordNpage.length/recordperpage)
    const numbers=[...Array(npage+1).keys()].slice(1)    
    const csrf=()=>axios.get('sanctum/csrf-cookie')
    

   //const recordperpage=2
    
    //const numbers=[1,2,3,4,5]
    const [loading,setLoading]=useState(false)
    

    useEffect(
        ()=>{
                Classes_initialesRequest()
        },[])
    const Classes_initialesRequest=async ()=>{
        await axios.get('api/classeinitiale').then(
            (res)=>{
                setClasses_initiales(res.data.items)
                setLoading(false)
            }
        ).catch((err)=>{
//
        })
    }
    const Iteration=()=>{
        return loading ? (
            <div className='w-100 mx-auto'>
                <img src={loadingIcon} alt='loading'/>
            </div>
        ) : (
            
                records.filter((classe_initiale)=>{
                    return search.toLowerCase() === '' ? classe_initiale : classe_initiale.nom.toLowerCase().includes(search)
                }).map((classe_initiale,indexV)=>
                {
                  return(
                        <tr key={indexV} className='ligne'>
                            <td>{indexV+1}</td>
                            <td>{classe_initiale.nom.toLowerCase()}</td>
                            <td>{classe_initiale.idsection}</td>
                            <td>{classe_initiale.niveau}</td>
                            <td><EyeFill color="lightgreen" size={20} className='d-inline-flex mx-2 icone'  /><PencilFill color="royalblue" size={20} className='d-inline-flex mx-2 icone' onClick={()=>navigate(`${classe_initiale.id}`)}/>  <Trash3Fill color='brown' size={20} className='d-inline-flex mx-2 icone' onClick={()=>AlertNotification(classe_initiale.id)} /> </td>
                        </tr>
                  )
                    
                }
                )
            
        )
        
            }   
            function AlertNotification(idclasse_initiale){
                Swal.fire({
                    title:'Etes-vous sûr de le supprimer ?',
                    text:'Ce cours sera supprimé',
                    icon:'warning',
                    showDenyButton:true,
                    showCancelButton:true,
                    confirmButtonText:'Confirmer',
                    denyButtonText:'Annuler'
                }).then((resultat)=>{
                    if(resultat.isConfirmed){
                        navigate(`/cours/delete/${idclasse_initiale}`)
                            }
                })
            }
    return(
        <>
        <div className="mt-2 mx-auto px-2 py-8 bg-primary">
            
            <div className='d-inline-flex w-75'> 
               <h1 className="text-light text-lg d-inline-flex w-50">
                Liste des cours déjà inscrits (Total : {classes_initiales.length})
                </h1>
                <div className="d-inline-flex w-50 mx-auto text-center">
                    <button name="ajouter" id="ajouter" onClick={()=>navigate('insertion')} className='btn btn-success d-inline-flex w-50 mx-auto  ' ><span className='text-center'> <PersonPlus color='white' size={25} className='d-inline-flex' /> Ajouter une classe </span></button>

                </div>
            </div>
            <div className='d-inline-flex w-25'>
                <input type="text" name="recherche" id="recherche" placeholder='Rechercher un élève' className='form-control form-control-sm'  onChange={(e)=>setSearch(e.target.value.toLowerCase())} value={search} />

            </div>
        </div>
        <div>
           <table className="table table-striped table-hover">
                <thead className='thead-light'>
                    <tr className=''>
                        <th >#</th>
                        <th>Classe</th>
                        <th>Section</th>
                        <th>Niveau</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody className="text-slate-700 text-xs">
                    {Iteration()}
                </tbody>
           </table>

        </div>
        <nav>
                <ul className='pagination mt-2 mx-4'>
                    <li className='page-item  '>
                        <a href="#" className='page-link' onClick={Prepage}>Prev</a>
                    </li>
                {
                    numbers.map((number,index)=>{
                        return(
                            <li className={`page-item ${curentpage === number ? 'active': '' }`} key={index}>
                                <a href="#" className='page-link' onClick={()=>changeCPage(number)}>{number}</a>
                            </li>
                        )
                    })
                    
                }
                    <li className='page-item '>
                        <a href="#" className='page-link' onClick={Nextpage}>Next</a>
                    </li>
                    <span className='mr-8'>
                    <input type="number" name="nbrperpag" className='form-control' id="nbrperpag" placeholder='Nombre par page' value={recordperpage} onChange={(e)=>setRecordperpage(e.target.value !== '' ? e.target.value : 1)} onBlur={()=>setCurentpage(1)} />
                    </span>
                </ul>
        </nav>
        </>
    )
function Prepage(){
    if(curentpage > 1){
        setCurentpage(curentpage-1)
    }
}
function changeCPage(id){
   setCurentpage(id)
}
function Nextpage(){
    if(curentpage < npage){
       // alert(curentpage)
        setCurentpage(curentpage+1)
    }
}

}
export default Classe

